import React from 'react';
import { Box, Typography, Button, CircularProgress, alpha } from '@mui/material';
import { TrendingDown, Radar } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';

const ScannerHeader = ({ loading, lastScan, onScan }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{
          width: 44, height: 44, borderRadius: '12px', flexShrink: 0,
          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: `0 3px 10px ${alpha('#ef4444', 0.25)}`,
        }}>
          <TrendingDown sx={{ fontSize: 22, color: '#fff' }} />
        </Box>
        <Box>
          <Typography sx={{ fontWeight: 700, color: '#0f172a', fontSize: '1.2rem', letterSpacing: '-0.01em' }}>
            {t('downshift.title')}
          </Typography>
          <Typography sx={{ color: '#94a3b8', fontSize: '0.75rem', mt: 0.15 }}>
            {t('downshift.description.part1')}{' '}
            <Box component="span" sx={{ fontWeight: 700, color: '#475569' }}>
              {t('downshift.description.highlight')}
            </Box>
          </Typography>
          {lastScan && (
            <Typography sx={{ fontSize: '0.7rem', color: '#b0b8c4', fontWeight: 400, mt: 0.15 }}>
              {format(lastScan, 'HH:mm:ss')}
            </Typography>
          )}
        </Box>
      </Box>

      <Button
        variant="outlined"
        size="small"
        startIcon={loading ? <CircularProgress size={14} /> : <Radar sx={{ fontSize: 16 }} />}
        onClick={onScan}
        disabled={loading}
        sx={{
          borderRadius: '10px',
          borderColor: loading ? '#ef4444' : '#e2e8f0',
          color: loading ? '#ef4444' : '#64748b',
          fontWeight: 600,
          fontSize: '0.75rem',
          textTransform: 'none',
          px: 2,
          '&:hover': {
            borderColor: '#ef4444',
            color: '#ef4444',
            backgroundColor: alpha('#ef4444', 0.04),
          },
        }}
      >
        {loading ? t('downshift.scanning') : t('downshift.scan')}
      </Button>
    </Box>
  );
};

export default ScannerHeader;
